(function () {
  if (customElements.get("deferred-autoplay-media")) {
    return;
  }

  class DeferredAutoplayMedia extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = null;
      this.isLoaded = false;
      this.isReady = false;
      this.handleIntersection = this.handleIntersection.bind(this);
      this.markReady = this.markReady.bind(this);
    }

    connectedCallback() {
      if (this.hasAttribute("eager") || this.isNearViewport()) {
        this.load();
        this.play();
      }

      if (!("IntersectionObserver" in window)) {
        this.load();
        this.play();
        return;
      }

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        rootMargin: "600px 0px",
        threshold: 0.01,
      });

      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      this.pause();
    }

    handleIntersection(entries) {
      for (const entry of entries) {
        if (entry.target !== this) continue;

        if (entry.isIntersecting) {
          this.load();
          this.play();
        } else {
          this.pause();
        }
      }
    }

    isNearViewport() {
      const rect = this.getBoundingClientRect();
      return rect.top < window.innerHeight * 1.35 && rect.bottom > -window.innerHeight * 0.25;
    }

    markReady() {
      if (this.isReady) return;

      this.isReady = true;
      this.setAttribute("loaded", "");
    }

    load() {
      if (this.isLoaded) return;

      const template = this.querySelector("template");
      if (!template) return;

      this.appendChild(template.content.cloneNode(true));
      this.isLoaded = true;

      const iframe = this.querySelector("iframe[data-src]");
      if (iframe && !iframe.src) {
        iframe.addEventListener("load", this.markReady, { once: true });
        iframe.src = iframe.dataset.src;
        window.setTimeout(this.markReady, 1200);
      }

      const video = this.querySelector("video");
      if (video) {
        if (video.readyState >= 2) {
          this.markReady();
        } else {
          video.addEventListener("loadeddata", this.markReady, { once: true });
          video.addEventListener("canplay", this.markReady, { once: true });
          window.setTimeout(this.markReady, 1200);
        }
      }

      if (!iframe && !video) {
        this.markReady();
      }
    }

    play() {
      const video = this.querySelector("video");
      if (video) {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      }
    }

    pause() {
      const video = this.querySelector("video");
      if (video) {
        video.pause();
      }
    }
  }

  customElements.define("deferred-autoplay-media", DeferredAutoplayMedia);
})();
